// extracted by mini-css-extract-plugin
export var navLink = "FooterNavLink-module--nav-link--389b6";